import { foodImage } from "@/assets";

const Template13 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const fallback = (value, defaultText) => {
    if (value === null || value === undefined || value === "") {
      return isStrictPreview ? "" : defaultText;
    }
    return value;
  };

  const backgroundImage =
    template?.image_url ||
    template?.image?.file_url ||
    template?.file_url ||
    previewData?.image_url ||
    previewData?.image?.file_url ||
    previewData?.template?.image_url ||
    previewData?.template?.image?.file_url ||
    foodImage;
  const title = fallback(previewData?.title, "Points Award");
  const customerName = fallback(previewData?.customerName, "Royel Tanduri");
  const code = fallback(previewData?.code, "32154232");
  const rewardLabel = previewData?.rewardLabel || "";
  const eligiblePoints = fallback(previewData?.eligibleRewardPoints, "50");
  const minimumRequiredPoints = fallback(previewData?.minimumRequiredPoints, "5");

  const isDiscount = rewardLabel.includes("£") || rewardLabel.includes("%") || rewardLabel.toLowerCase().includes("off");
  const offerSentence = rewardLabel 
    ? (isDiscount ? `For ${eligiblePoints} points get ${rewardLabel} off` : `For ${eligiblePoints} points get ${rewardLabel}`)
    : `For ${eligiblePoints} points get reward`;
  const eligibilitySentence = `Minimum ${minimumRequiredPoints} points to be eligible for this offer`;

  const message = fallback(previewData?.message || previewData?.template_note, "Wish you a happy day.");
  const isConjunction = previewData?.isConjunction ?? previewData?.is_conjunction ?? (isStrictPreview ? false : true);

  return (
    <div className="flex items-center justify-center p-4">
      <div
        data-export-capture="point-based-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex items-end justify-center"
      >
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        ></div>
        <div className="relative z-10 w-[78%] h-[82%] bg-white rounded-t-[60px] flex flex-col items-center justify-between pt-6 pb-4 px-6 shadow-2xl text-center">
          <div className="w-full">
            <h1 className="text-2xl font-bold text-[#9C7A4E] tracking-tight leading-none mb-0.5">
              {title}
            </h1>
            <p className="text-base font-serif font-bold text-black/80 italic mb-1.5">
              {customerName}
            </p>
            <div className="flex items-center justify-center gap-2 text-xs">
              <span className="bg-gray-100 text-gray-800 px-2 py-0.5 rounded border border-gray-200">
                Code: {code}
              </span>
              {rewardLabel && (
                <span className="bg-amber-100 text-amber-800 px-2 py-0.5 rounded font-semibold border border-amber-200">
                  Offer: {rewardLabel}
                </span>
              )}
            </div>
          </div>

          <div className="my-1.5 px-4 w-full">
            <h2 className="text-2xl font-extrabold tracking-tight text-[#9C7A4E] leading-tight mb-1">
              {offerSentence}
            </h2>
            <p className="text-xs text-gray-600 font-medium">
              {eligibilitySentence}
            </p>
          </div>

          <div className="w-full">
            {message ? (
              <p className="text-xs text-gray-500 italic max-w-sm line-clamp-1 mx-auto">
                {message}
              </p>
            ) : (
              <div className="h-3" />
            )}
            {isConjunction && (
              <p className="text-[10px] text-red-600/90 font-semibold mt-0.5">
                Not conjunction with any other offer
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template13;
